import { render } from "./InvoiceInventory.vue?vue&type=template&id=013b0610&scoped=true"
import script from "./InvoiceInventory.vue?vue&type=script&lang=js"
export * from "./InvoiceInventory.vue?vue&type=script&lang=js"

import "./InvoiceInventory.vue?vue&type=style&index=0&id=013b0610&lang=scss&scoped=true"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013b0610"]])

export default __exports__